// libraries
import styled from 'styled-components';

export const StyledFileUpload = styled.div`
  .create-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px;
  }

  .create-desc {
    font-size: 13px;
    color: var(--color-text-gray);
    margin: 0 0 16px;
  }

  .create-upload {
    height: 40px;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid var(--color-pale-gray);
    border-radius: 6px;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    > span {
      font-size: 14px;
      font-weight: 400;
      color: var(--color-text-gray);
      text-transform: none;

      b {
        color: var(--color-primary-blue);
        font-weight: 400;
      }
    }
  }

  .create-file-list {
    margin-top: 16px;
    max-height: 240px;
    overflow-y: auto;

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--color-pale-gray);
      border-radius: 6px 6px 0 0;
      background: var(--color-off-white);
      padding: 8px 16px;
      font-size: 13px;
      color: var(--color-text-gray);
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--color-pale-gray);
      border-top: none;
      padding: 8px 16px;
      font-size: 14px;

      &-left {
        display: flex;
        align-items: center;
        gap: 8px;

        > p {
          color: var(--color-medium-gray);
        }
      }

      &-right {
        color: var(--color-medium-gray);
      }
    }
  }

  .delete-btn {
    width: 19px;
    min-width: 19px;
    height: 19px;
    border-radius: 50%;
    box-shadow: none;
    background: var(--color-off-white);
    padding: 0;

    > img {
      width: 12px;
      height: 12px;
    }
  }
`;
